(() => {
  const selector = 'localization-form';
  const close = (form) => {
    const button = form.querySelector('.localization-selector');
    const list = form.querySelector('.disclosure__list-wrapper');
    if (button) button.setAttribute('aria-expanded', 'false');
    if (list) list.hidden = true;
  };
  const open = (form) => {
    document.querySelectorAll(selector).forEach((other) => { if (other !== form) close(other); });
    const button = form.querySelector('.localization-selector');
    const list = form.querySelector('.disclosure__list-wrapper');
    if (button) button.setAttribute('aria-expanded', 'true');
    if (list) list.hidden = false;
  };
  const handle = (event) => {
    const button = event.target.closest(`${selector} .localization-selector`);
    if (button) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const form = button.closest(selector);
      const list = form?.querySelector('.disclosure__list-wrapper');
      if (!form || !list) return;
      list.hidden ? open(form) : close(form);
      return;
    }
    const option = event.target.closest(`${selector} .disclosure__link[data-value]`);
    if (option) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const form = option.closest('form');
      if (!form) return;
      let input = form.querySelector('input[name="country_code"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'country_code';
        form.append(input);
      }
      input.value = option.dataset.value;
      form.requestSubmit();
      return;
    }
    document.querySelectorAll(selector).forEach((form) => { if (!form.contains(event.target)) close(form); });
  };
  document.addEventListener('click', handle, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll(selector).forEach(close);
  }, true);
})();
